import * as React from "react";

import BasicTable from "../Table/BasicTable";
import { Field } from "../Table";
import { DateCell } from "../../Displays";

const DATE_FORMAT = "YYYY-MM-DD";

export default ({ reportRows, fromDate, toDate }) => {
  const data = React.useMemo(() => {
    return reportRows;
  }, [reportRows]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Fakturerad part",
        accessor: "DebtorName",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
        Footer: () => {
          return <Field style={{ fontWeight: 600 }}>Total sida:</Field>;
        },
        TotalFooter: () => {
          return <Field style={{ fontWeight: 600 }}>Total:</Field>;
        },
      },
      {
        Header: "Produktbeskrivning",
        accessor: "ProductDescription",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },

      {
        Header: "Fakturadatum",
        accessor: "TransactionDate",
        Cell: (props) => {
          return <DateCell date={props.value} />;
        },
      },
      {
        Header: "Periodstart",
        accessor: "PeriodStart",
        Cell: (props) => {
          return <DateCell date={props.value} />;
        },
      },
      {
        Header: "Periodslut",
        accessor: "PeriodEnd",
        Cell: (props) => {
          return <DateCell date={props.value} />;
        },
      },
      {
        Header: "Kvantitet",
        accessor: "Quantity",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Enhet",
        accessor: "Units",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Belopp (SEK)",
        accessor: "Amount.ValueForView",
        Cell: (props) => {
          return <Field>{props.value.toLocaleString("sv")}</Field>;
        },
        Footer: (props) => {
          const summarized = props.page.reduce((acc, cur) => {
            const val = cur.original.Amount.ValueForView;
            return (acc += val);
          }, 0);

          return <Field>{summarized.toLocaleString("sv")}</Field>;
        },
        TotalFooter: (props) => {
          const summarized = props.data.reduce((acc, cur) => {
            const val = cur.Amount.ValueForView;
            return (acc += val);
          }, 0);

          return <Field>{summarized.toLocaleString("sv")}</Field>;
        },
      },
      {
        Header: "Kostnadsställe",
        accessor: "CostCenter",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Projekt",
        accessor: "Project",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
      {
        Header: "Bokföringskonto",
        accessor: "BookKeepingAccount",
        Cell: (props) => {
          return <Field>{props.value}</Field>;
        },
      },
    ],
    []
  );

  return (
    <>
      <BasicTable
        data={data}
        columns={columns}
        exportName={`forsaljning_per_produkt_${fromDate}-${toDate}`}
        withExport
        withSummaryFooter
        withTotalSummaryFooter
        tableId="periodicproductsalestable"
        withPersistantSortBy
        withPersistantGlobalFilter
      />
    </>
  );
};
